export default __webpack_public_path__ + "static/media/icon2.16c7cf22.svg";